// @ts-ignore
import React from "react";
import { NewModal } from '../uiMerge/newModal';

type MerchantInfoModalProps = {
  visible: boolean;
  onCancel: () => void;
  merchantIcon: string;
  merchantCaption: string;
  merchantAddress?: string;
};

const MerchantInfoModal = ({
  visible,
  onCancel,
  merchantCaption,
  merchantIcon,
  merchantAddress 
}: MerchantInfoModalProps) => {
  return (
    <NewModal
      isOpen={visible}
      roundedClass="rounded-[10px]"
      colorClass="bg-black"
      widthClass="w-[335px]"
      position="center"
      showCloseButton
      onClose={onCancel}
    >
      <div className="flex flex-col items-center mt-6 pt-[30px] pb-[25px] px-[24px] gap-3">
        <p className="font-extrabold text-white text-[20px]">About this Partner</p>
        
        <div className="flex flex-col px-2 overflow-y-auto show-scrollbar max-h-[346px] items-center gap-3">
          <div className="rounded-full">
            <img
              className="rounded-full w-[51px] h-[51px] object-cover"
              src={merchantIcon}
              alt="Merchant logo"
            />
          </div>
          <div className="flex justify-center">
            <p className="font-medium text-white text-[15px] text-center">
              {merchantCaption}
            </p>
          </div>
          
          
          <div className="flex flex-col items-center gap-1 ">
            <p className="font-extrabold text-white text-[14px]">Location:</p>
            <p className="font-medium text-white text-[12px] text-center">
              {merchantAddress}
            </p>
          </div>
        </div>
      </div>
    </NewModal>
  );
};

export default MerchantInfoModal;